<template>
    <app-layout title="Creditnota">
        <template #header>
            <page-title :title="'Creditnota ' + creditNote.request.reference" />
        </template>

        <template #pageContent>
            <Button
                htmlType="a"
                buttonClass="edit"
                text="Bewerken"
                :href="route('accountancy.credit-notes.edit', { 'id': creditNote.id })"
            />
            <ModalAttachments :request="creditNote.request" :attachments="attachments" :attachmentTypes="attachmentTypes" :attachmentsPath="attachmentsPath" />
            <Table class="border-0 mt-4 w-auto max-w-[500px]">
                <tr>
                    <Td class="border-0 pl-0">Aanvraag:</Td>
                    <Td class="border-0">
                        <a :href="route('requests.detail',  {'id': creditNote.request.id})" >
                            {{ creditNote.request.reference }}
                        </a>
                    </Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Status:</Td>
                    <Td class="border-0">{{ statusses[creditNote.request.status] }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Nummer creditnota:</Td>
                    <Td class="border-0">{{ creditNote.reference }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Bankrekeningnr.:</Td>
                    <Td class="border-0">{{ creditNote.bank_account }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Terug te betalen bedrag:</Td>
                    <Td class="border-0">{{ creditNote.refund }}<span v-if="creditNote.refund">€</span></Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Status creditnota:</Td>
                    <Td class="border-0">{{ statusses[creditNote.status] }}</Td>
                </tr>
                <tr>
                    <Td class="border-0 pl-0">Extra info boekhouding:</Td>
                    <Td class="border-0">{{ creditNote.info_accounting }}</Td>
                </tr>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'

import ModalAttachments from "@/Components/Requests/ModalAttachments.vue";

import store from '@/store'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        ModalAttachments,
    },
    props: [
        'creditNote',
        'statusses',
        'attachmentTypes',
        'attachmentsPath',
        'attachments',
    ],
    setup (props)
    {
        return {
            state: store.state,
            ...store,
        }
    },
}

</script>

<style scoped>
tr.nohover:hover td  {
    background: none;
}
</style>
